import { cx } from "@linaria/core";
import { FC, memo, useCallback, useEffect, useRef } from "react";
import { cssButtonInCart } from "@/components/Products/parts";
import { getRouteLinkYaMap } from "@/hooks/shops/helpers";
import { cssIsActive } from "@/styles/utils/Utils";
import { Button } from "@/ui/Button/Button";
import { Icon } from "@/ui/Icon";
import { ROUTES } from "@/utils/constants";
import { Content, StyledShop } from "./StyledShop";
import { cssButtonMore } from "../../Account/History/Order/Controls/StyledControls";
import { Address, Phone, Schedule } from "../parts";
import { ShopsPropsType } from "../types";
const Shop: FC<ShopsPropsType> = memo(({
  shop,
  onNameClick,
  children,
  withRouteToDetail,
  isSelected = false,
  isActivated = false,
  onSelectHandle,
  enableSelectShop = false,
  ...props
}) => {
  const {
    phone,
    schedule,
    address,
    coordinates
  } = shop;
  const shopRef = useRef<HTMLDivElement | null>(null);
  const onClickAddressHandle = () => {
    if (onNameClick) {
      onNameClick(shop);
    }
  };
  const onClickSelectHandle = () => {
    if (onSelectHandle) {
      onSelectHandle(shop.uuid);
    }
  };
  const toggleButton = enableSelectShop && <>
        {!isSelected ? <Button variant={"filled"} size={"small"} onClick={onClickSelectHandle}>
            Выбрать
          </Button> : <Button variant={"filled"} size={"small"} icon={"Check"} iconPosition={"left"} className={cssButtonInCart}>
            Выбрано
          </Button>}
      </>;
  const scrollToActive = useCallback(() => {
    const parentModal = shopRef.current?.closest(`[role="alertdialog"]`);
    if (!!parentModal) {
      parentModal.scrollTop += shopRef?.current?.offsetTop || 0;
    }
    const shopList = shopRef.current?.closest(`[role="shoplist"]`);
    if (!!shopList) {
      shopList.scrollTop += shopRef?.current?.offsetTop || 0;
    }
  }, []);
  useEffect(() => {
    if (!isSelected) {
      return;
    }
    scrollToActive();
  }, [isSelected, scrollToActive]);
  useEffect(() => {
    if (!isActivated) {
      return;
    }
    scrollToActive();
  }, [isActivated, scrollToActive]);
  return <StyledShop {...props} className={cx(isActivated && cssIsActive, props.className)} ref={shopRef}>
        <Icon NameIcon={"Location"} size={"default"} />
        <Content>
          <Address handleClick={onClickAddressHandle} address={address} />

          <Schedule schedule={schedule} />

          <Phone phone={phone} />

          {children}

          {!!withRouteToDetail && <Button variant={"small"} icon={"Info"} as={"a"} href={`${ROUTES.stores}/${shop.uuid}`} className={cssButtonMore}>
              Подробнее
            </Button>}

          <Button variant={"small"} icon={"NearMe"} as={"a"} href={getRouteLinkYaMap({
        latitude: coordinates?.latitude || "",
        longitude: coordinates?.longitude || "",
        text: address
      })} target={"_blank"} className={cssButtonMore}>
            Построить маршрут
          </Button>

          {toggleButton}
        </Content>
      </StyledShop>;
});
Shop.displayName = "Shop";
export { Shop };